import React from 'react';
import { useTranslation } from 'react-i18next';
import { Undo2 } from 'lucide-react';

/**
 * "Cancel" next to a present/absent control: takes the mark back to "not
 * marked". Rendered only while there is a mark to cancel.
 */
export default function ClearAttendanceButton({ status, onClear, disabled = false, testId = 'attendance-clear', compact = false }) {
  const { t } = useTranslation();
  if (!status) return null;
  const label = t('attendance.clearMark', { defaultValue: 'Cancel mark' });
  return (
    <button
      type="button"
      onClick={onClear}
      disabled={disabled}
      title={label}
      aria-label={label}
      data-testid={testId}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        padding: compact ? '0.25rem 0.5rem' : '0.375rem 0.625rem',
        minHeight: compact ? 32 : 40,
        borderRadius: 'var(--radius-md, 8px)',
        border: '1px solid var(--border-default, #D1D5DB)',
        background: 'var(--surface-base, #fff)',
        color: 'var(--text-secondary, #6B7280)',
        fontSize: compact ? 'var(--font-size-xs, 0.75rem)' : 'var(--font-size-sm, 0.875rem)',
        fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      <Undo2 size={14} aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
